const networkRequest = require("./src/network-request");
const workerUtils = require("./src/worker-utils");

module.exports = {
  networkRequest,
  workerUtils,
};



// WEBPACK FOOTER //
// /Users/jlaster/src/mozilla/devtools-core/packages/devtools-utils/index.js